// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminEnrollmentsController from "./admin_enrollments_controller"
application.register("admin-enrollments", AdminEnrollmentsController)

import AdminFilterController from "./admin_filter_controller"
application.register("admin-filter", AdminFilterController)

import AdminQuizSubmissionsController from "./admin_quiz_submissions_controller"
application.register("admin-quiz-submissions", AdminQuizSubmissionsController)

import AdminTicketsController from "./admin_tickets_controller"
application.register("admin-tickets", AdminTicketsController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatRoomsController from "./chat_rooms_controller"
application.register("chat-rooms", ChatRoomsController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CoursesFilterController from "./courses_filter_controller"
application.register("courses-filter", CoursesFilterController)

import DiscountController from "./discount_controller"
application.register("discount", DiscountController)

import EnrolledCoursesController from "./enrolled_courses_controller"
application.register("enrolled-courses", EnrolledCoursesController)

import FavoritesController from "./favorites_controller"
application.register("favorites", FavoritesController)

import FlickityController from "./flickity_controller"
application.register("flickity", FlickityController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KeyboardController from "./keyboard_controller"
application.register("keyboard", KeyboardController)

import LessonIdiomController from "./lesson_idiom_controller"
application.register("lesson-idiom", LessonIdiomController)

import LessonsBrowseController from "./lessons_browse_controller"
application.register("lessons-browse", LessonsBrowseController)

import MatchingQuestionController from "./matching_question_controller"
application.register("matching-question", MatchingQuestionController)

import NestedQuestionsController from "./nested_questions_controller"
application.register("nested-questions", NestedQuestionsController)

import OrderingQuestionController from "./ordering_question_controller"
application.register("ordering-question", OrderingQuestionController)

import PaymentTransactionsController from "./payment_transactions_controller"
application.register("payment-transactions", PaymentTransactionsController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import ResultModalController from "./result_modal_controller"
application.register("result-modal", ResultModalController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RolePermissionsController from "./role_permissions_controller"
application.register("role-permissions", RolePermissionsController)

import SectionsBrowseController from "./sections_browse_controller"
application.register("sections-browse", SectionsBrowseController)

import SoundPlayerController from "./sound_player_controller"
application.register("sound-player", SoundPlayerController)

import StudentEnrollmentsController from "./student_enrollments_controller"
application.register("student-enrollments", StudentEnrollmentsController)

import TrackSelectorController from "./track_selector_controller"
application.register("track-selector", TrackSelectorController)

import TutorSessionRequestsController from "./tutor_session_requests_controller"
application.register("tutor-session-requests", TutorSessionRequestsController)

import TutorsFilterController from "./tutors_filter_controller"
application.register("tutors-filter", TutorsFilterController)
